import HTTP from '@/utils/http'

export default class AccountModel extends HTTP {
  /**
   * 获取剩余LILY币
   */
  coin() {
    return this.get({
      url: '/account/coin',
    })
  }

  /**
   * LILY币/余额流水
   */
  list(params) {
    return this.get({
      url: '/account/record',
      params,
    })
  }

  awaredList(params){
    return this.get({
        url:'/account/award/list',
        params,
    })
  }

  awaredBaseList(params){
    return this.get({
        url:'/account/award/base/list',
        params
    })
  }
}
